import React from 'react';
import { Classes } from '@blueprintjs/core';
import classNames from 'classnames';
import { HeadingProps } from 'core/components/types';
import Box from './Box';

const Heading = ({ level, className, fontWeight, color, ...rest }: HeadingProps) => {
  if (level <= 2 && !fontWeight) {
    // @ts-expect-error yeah this is invalid code but I don't want to mess with it right now
    fontWeight = 'heavy';
  }

  if (!level) {
    console.warn('Heading specified with no level');
  }

  return (
    <Box
      fontWeight={fontWeight}
      color={color || undefined}
      {...rest}
      aria-level={level}
      as={`h${level}`}
      className={classNames(Classes.HEADING, className)}
    />
  );
};

export default Heading;
